"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function EnforcementSection() {
  const { t } = useLanguage();

  return (
    <section className="bg-white py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-[880px] mx-auto">
        <h2 className="text-xl md:text-[28px] font-black text-[#064e3b] mb-4">
          {t("access.h2Enforcement")}
        </h2>
        <p className="text-[#374151] leading-[1.7] mb-4">
          {t("access.enforcementText")}
        </p>
        <p className="text-sm text-[#374151]/70 italic">
          {t("access.enforcementFooter")}
        </p>
      </div>
    </section>
  );
}